import { memo } from 'react';
import { Banners } from '@bonanza-social/banners';
import { Box } from '@bonanza-social/moonlight';
import { useBreakpoint, Breakpoint } from '@bonanza-social/moonlight';
import Filters from '../../Filters/Filters';

function CategoriesHeader() {
  const breakpoint = useBreakpoint();

  return (
    <Box gap="space-300">
      {breakpoint === Breakpoint.MOBILE ? (
        <Box>
          <Banners />
        </Box>
      ) : null}
      <Filters />
    </Box>
  );
}

export default memo(CategoriesHeader);
